import * as accountsActions from '../actions/Accounts';

const initialState = {
  account: {},
  error: false,
  status: 200,
  error_message: '',
  reIdentity: false
};

const accounts = (state = initialState, action) => {
  switch (action.type) {
    case accountsActions.GET_ACCOUNT_SUCCESS:
      return Object.assign({}, state, { account: action.payload });
    case accountsActions.GET_ACCOUNT_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case accountsActions.RE_IDENTITY_ACTION:
      return Object.assign({}, state, {
        reIdentity: action.payload.status
      });
    default:
      return state;
  }
};

export default accounts;
